export const POLYGON_FILL_SVG = {
	verticalline: {
		svg: `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50">
			<line x1="25" y1="0" x2="25" y2="50" stroke="#000000" stroke-width="1"/>
		</svg>`,
		width: 5,
		height: 5,
	},
	carrow: {
		svg: `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50">
			<polygon points="10,10 40,25 10,40" fill="#000000"/>
		</svg>`,
		width: 10,
		height: 10,
	},
	horizontalline: {
		svg: `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50">
			<line x1="0" y1="25" x2="50" y2="25" stroke="#000000" stroke-width="1"/>
			</svg>`,
		width: 5,
		height: 10,
	},
	backslash: {
		svg: `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50">
			<line x1="0" y1="0" x2="50" y2="50" stroke="#000000" stroke-width="1"/>
			</svg>`,
		width: 10,
		height: 5,
	},
	slash: {
		svg: `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50">
			<line x1="0" y1="50" x2="50" y2="0" stroke="#000000" stroke-width="1"/>
		</svg>`,
		width: 5,
		height: 10,
	},
	dot: {
		svg: `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50">
				<circle cx="25" cy="25" r="3" fill="#000000"/>
			</svg>`,
		width: 10,
		height: 10,
	},
	grid: {
		svg: `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50">
			<line x1="25" y1="0" x2="25" y2="50" stroke="#000000" stroke-width="2"/>
			<line x1="0" y1="25" x2="50" y2="25" stroke="#000000" stroke-width="2"/>
		</svg>`,
		width: 9,
		height: 3,
	},
	diagonalgrid: {
		svg: `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50">
	        <line x1="0" y1="0" x2="50" y2="50" stroke="#000000" stroke-width="1"/>
	        <line x1="0" y1="50" x2="50" y2="0" stroke="#000000" stroke-width="1"/>
	      </svg>`,
		width: 10,
		height: 5,
	},
	oarrow: {
		svg: `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50">
	        <path d="M 10 10 L 40 25 L 10 40" stroke="#000000" fill="none" stroke-width="1"/>
	      </svg>`,
		width: 10,
		height: 10,
	},
};
